/**
 * Auth yüzeyleri. Boyutlar AuthStage'deki --auth-* değişkenlerinden gelir;
 * light tema koyu temadaki cam hissini takip eder, sert siyah/beyaz kaçınılır.
 */

export const authStackClass =
  "flex flex-col gap-[length:var(--auth-stack-gap,1.5rem)]";

export const authTitleClass = [
  "font-semibold tracking-tight text-text-primary dark:text-gray-100",
  "[font-size:var(--auth-title-size,1.625rem)] [line-height:1.25]",
].join(" ");

export const authSubtitleClass =
  "text-sm text-muted-foreground flex items-center gap-1.5";

export const authLinkClass = [
  "text-text-secondary dark:text-gray-100 underline font-semibold",
  "hover:text-muted-foreground transition-colors inline-flex",
].join(" ");

export const authLabelClass =
  "text-sm font-medium block text-text-secondary dark:text-gray-200";

export const authFormClass =
  "flex flex-col gap-[length:var(--auth-form-gap,1.125rem)]";

export const authSocialStackClass =
  "flex flex-col gap-[length:var(--auth-social-gap,0.625rem)]";

export const authFooterClass = [
  "flex flex-col gap-3 border-t border-black/[0.06] dark:border-white/10",
  "[margin-top:var(--auth-footer-gap,1rem)] [padding-top:var(--auth-footer-gap,1rem)]",
].join(" ");

/** Giriş alanları: butonlarla aynı ince cam. */
export const authFieldClass = [
  "h-[var(--auth-field-h,2.5rem)] rounded-full shadow-none backdrop-blur-xl",
  "border-black/[0.06] bg-black/[0.03] text-text-primary placeholder:text-text-quaternary",
  "dark:border-white/15 dark:bg-white/[0.06] dark:text-gray-100",
  "focus:[outline-color:rgb(167_139_250/0.55)]",
].join(" ");

export const authSocialButtonClass = [
  "w-full h-[var(--auth-btn-h,2.5rem)] rounded-full shadow-none backdrop-blur-xl",
  "inline-flex items-center justify-center gap-2 px-3 text-sm font-medium",
  "border-black/[0.06] bg-black/[0.03] text-text-secondary",
  "dark:border-white/15 dark:bg-white/[0.06] dark:text-gray-100",
  "hover:bg-black/[0.055] dark:hover:bg-white/[0.1]",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background",
  "disabled:pointer-events-none disabled:opacity-60",
].join(" ");

export const authPrimaryButtonClass = [
  "relative isolate overflow-hidden w-full h-[var(--auth-btn-h,2.5rem)] rounded-full font-semibold",
  /* text-primary-900: light'ta kömür, koyuda yumuşak beyaz */
  "bg-[#424650]/75 text-white backdrop-blur-xl dark:bg-white/80 dark:text-gray-900",
  "shadow-[0_6px_16px_-8px_rgba(15,23,42,0.16)] hover:shadow-[0_8px_20px_-8px_rgba(15,23,42,0.2)]",
  "dark:shadow-[0_6px_24px_-8px_rgba(255,255,255,0.25)] dark:hover:shadow-[0_10px_32px_-6px_rgba(255,255,255,0.38)]",
  "transition-[transform,box-shadow,background-color,color] duration-200 hover:-translate-y-px active:translate-y-0 active:scale-[0.97]",
  "before:pointer-events-none before:absolute before:inset-0 before:bg-gradient-to-b before:from-white/[0.14] before:to-transparent dark:before:from-transparent dark:before:to-black/[0.06]",
  "after:pointer-events-none after:absolute after:inset-x-3 after:bottom-0 after:h-px after:bg-gradient-to-r after:from-transparent after:via-violet-400 after:to-transparent after:opacity-0 after:transition-opacity after:duration-300 hover:after:opacity-100 dark:after:via-violet-500",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background",
  "disabled:translate-y-0 disabled:scale-100 disabled:shadow-none disabled:opacity-40",
  "disabled:bg-black/[0.04] disabled:text-text-quaternary disabled:ring-1 disabled:ring-inset disabled:ring-black/[0.06]",
  "dark:disabled:bg-white/[0.06] dark:disabled:text-gray-500 dark:disabled:ring-white/[0.08]",
].join(" ");
